import type { ReactNode } from 'react';
import { View, Text } from 'react-native';
import { Button } from './Button';

interface EmptyStateProps {
  title: string;
  message: string;
  icon?: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({ title, message, icon, actionLabel, onAction }: EmptyStateProps) {
  return (
    <View className="flex-1 items-center justify-center p-8">
      {icon ? <View className="mb-4">{icon}</View> : <Text className="text-4xl mb-4">📭</Text>}
      <Text className="text-lg font-semibold text-gray-800 dark:text-gray-200 text-center mb-2">{title}</Text>
      <Text className="text-sm text-gray-500 dark:text-gray-400 text-center mb-6">{message}</Text>
      {actionLabel && onAction && (
        <Button onPress={onAction} size="sm">
          {actionLabel}
        </Button>
      )}
    </View>
  );
}
